<template>
  <CreateChatbotForm />
</template>

<script>
import CreateChatbotForm from '../components/CreateChatbotComponent.vue'

export default {
  name: 'CreateChatbotView',
  components: {
    CreateChatbotForm
  }
}
</script>

<style scoped>
/* Les styles sont gérés par le composant */
</style> 